import Form, {
    ButtonItem,
    EmailRule,
    GroupItem,
    RequiredRule,
    SimpleItem,
    Label,
    CompareRule,
    StringLengthRule,
    PatternRule
} from 'devextreme-react/form';
import {useSnackbar} from 'notistack';
import format from "date-fns/format";
import {CheckBox} from 'devextreme-react';
import {Validator} from 'devextreme-react/validator';
import {useEffect, useRef, useState} from "react";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {auth, db} from "../../../../firebase/Firebase";
import {permits} from "../../../../utils/UsersPermits";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import Alerts from "../../../../palette/Alerts";
import {inject, observer} from "mobx-react";
import {useMountedState} from "../../../../utils/UnMounted";
import {Link, useHistory,} from "react-router-dom";

const dataAccount = {
    email: '',
    password: '',
    compare: '',
    companyName: '',
    privacy: false,
};

const passwordOptions = {
    mode: 'password'
};

const date = format(new Date(), 'yyyy-MM-dd');

const namePattern = /^[a-zA-Z0-9 ]*$/;

function CreateAccount(props) {

    const {setCreate, setLogin, SessionStore} = props
    const {fromPrivacy} = SessionStore

    const [submitButton, setSubmitButton] = useState({
        ...buttonSuccess,
        icon: 'fas fa-plus-circle',
        text: 'Crear cuenta'
    })
    const [space, setSpace] = useState(false);
    const [companyAccount, setCompanyAccount] = useState(dataAccount)
    const [success, setSuccess] = useState(false)

    const dxForm = useRef(null);
    const {enqueueSnackbar} = useSnackbar();
    const isMounted = useMountedState()
    let history = useHistory();

    useEffect(() => {
        if (isMounted()) {
            if (!fromPrivacy) {
                const {instance} = dxForm.current
                instance.resetValues()
            }
        }
    }, [fromPrivacy, isMounted])

    const onValueChanged = () => {
        const str = dataAccount.email;
        if (str.indexOf(' ') >= 0) {
            setSpace(true)
        } else {
            setSpace(false)
        }
    }

    const spaceRender = () => {
        return (
            <div>
                {space &&
                <span style={{fontSize: 12, color: 'red'}}>El correo electronico contiene espacios en blanco</span>}
            </div>
        )
    }

    const renderSuccess = () => {
        return (<Alerts severity="error" body={'Debe aceptar los términos de privacidad y uso!'}/>
        )
    }

    const onChangeAccount = (key, e) => {
        setSuccess(!e.value)
        setCompanyAccount({...companyAccount, [key]: e.value})
    }

    const privacy = () => {
        return (
            <div style={styles.checkbox}>
                <CheckBox
                    elementAttr={{id: 'check-box-privacy'}}
                    // text={'Aceptar los términos de privacidad y uso'}
                    value={companyAccount.privacy}
                    onValueChanged={(e) => onChangeAccount('privacy', e)}
                >
                    <Validator>
                        <RequiredRule message="Debe aceptar los términos de privacidad y uso"/>
                    </Validator>
                </CheckBox>
                <Link target="_blank" to={"/privacy"} style={{color: "gray", marginLeft: 7}}>
                    Aceptar los términos de privacidad y uso
                </Link>
                {/*  <Text text={'Aceptar los términos de privacidad y uso'} hover left={5} size={10} weight={'600'}
                      onClick={onClickPrivacy}/>*/}
            </div>
        )
    }

    const passwordComparison = () => {
        return companyAccount.password;
    };

    const onSubmitRegister = async (e) => {
        e.preventDefault();

        const {instance} = dxForm.current
        if (!companyAccount.privacy) {
            setSuccess(!companyAccount.privacy)
        } else {
            setSubmitButton({...submitButton, icon: 'fa fa-spinner fa-spi', disabled: true, text: 'Enviando...'})
            await auth.createUserWithEmailAndPassword(companyAccount.email, companyAccount.password)
                .then(async () => {
                    let user = auth.currentUser;

                    delete companyAccount.compare

                    await user.updateProfile({
                        displayName: companyAccount.companyName
                    })

                    const dataUser = {
                        companyName: companyAccount.companyName,
                        idCompany: user.uid,
                        role: 'sroot',
                        companyMail: companyAccount.email,
                        userEmail: companyAccount.email,
                        ID: 1,
                        finished: false,
                        permits: permits,
                        dateCreation: date,
                        status: true,
                        username: 'Administrador'
                    }

                    await db.collection('Users').doc(user.uid).set(dataUser)
                        .then(async () => {
                            await user.sendEmailVerification().then(() => {
                                NotiStackInfo('Su cuenta ha sido creada exitosamente!', 'success', enqueueSnackbar)
                                NotiStackInfo('En breve recibirá un correo electrónico!', 'info', enqueueSnackbar)
                                instance.resetValues()
                                setSubmitButton({
                                    ...submitButton,
                                    icon: 'fas fa-plus-circle',
                                    disabled: false,
                                    text: 'Crear cuenta'
                                })
                                history.push('/')
                                setCreate(false)
                                setLogin(true)
                            }).catch(() => {
                                setSubmitButton({
                                    ...submitButton,
                                    icon: 'fas fa-plus-circle',
                                    disabled: false,
                                    text: 'Crear cuenta'
                                })
                            })
                        }).catch(() => {
                            setSubmitButton({
                                ...submitButton,
                                icon: 'fas fa-plus-circle',
                                disabled: false,
                                text: 'Crear cuenta'
                            })
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                        })
                }).catch(() => {
                    setSubmitButton({
                        ...submitButton,
                        icon: 'fas fa-plus-circle',
                        disabled: false,
                        text: 'Crear cuenta'
                    })
                    NotiStackInfo('Esta cuenta ya a sido registrada!', 'error', enqueueSnackbar)
                })
        }
    }

    return (
        <>
            <form action="" onSubmit={onSubmitRegister}>
                <Form
                    ref={dxForm}
                    formData={dataAccount}
                    readOnly={false}
                    showColonAfterLabel={true}
                    validationGroup="customerData"
                >
                    <GroupItem caption="Crear cuenta" colCount={1}>
                        <SimpleItem dataField="companyName" label={{text: 'Nombre de la empresa', location: 'top'}}
                                    editorOptions={{maxLength: 51}}>
                            <RequiredRule message="Ingrese el nombre de la empresa"/>
                            <PatternRule message="No se permiten caracteres especiales" pattern={namePattern}/>
                            <StringLengthRule message="El nombre de la empresa no debe tener más de 50 caracteres"
                                              max={50}/>
                        </SimpleItem>
                        <SimpleItem dataField="email" label={{text: ' Correo electrónico', location: 'top'}}
                                    editorOptions={{onValueChanged: onValueChanged, maxLength: 70}}>
                            < EmailRule message="Correo electrónico invalido" ignoreEmptyValue={true} type={'email'}/>
                            <RequiredRule message="Ingrese el correo electrónico de usuario"/>
                        </SimpleItem>
                        <SimpleItem dataField="password" label={{text: 'Contraseña', location: 'top'}}
                                    editorOptions={passwordOptions}>
                            <RequiredRule message="Ingrese una contraseña"/>
                            <StringLengthRule min={6} max={10}
                                              message="La contraseña debe tener al menos 6 caracteres y maximo 10"/>
                        </SimpleItem>
                        <SimpleItem dataField='compare' editorType="dxTextBox" editorOptions={passwordOptions}>
                            <Label text="Confirmar contraseña" location={'top'}/>
                            <RequiredRule message="Debe confirmar la contraseña"/>
                            <CompareRule
                                message="Las contraseñas no coinciden"
                                comparisonTarget={passwordComparison}
                            />
                        </SimpleItem>
                        <SimpleItem render={privacy} label={{text: ''}}>
                            <RequiredRule message="Debe aceptar los términos de privacidad y uso."/>
                        </SimpleItem>
                        <SimpleItem render={spaceRender}/>
                        {success && <SimpleItem render={renderSuccess}/>}
                        <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                    </GroupItem>
                </Form>
            </form>
        </>
    )
}

export default inject('SessionStore')(observer(CreateAccount));

const styles = {
    checkbox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%'
    }
}